<template>
    <Link v-if="link" :class="classname" :link="link">
      <slot></slot>
    </Link>
    <Link v-else-if="link_url" :class="classname" :post_link="link_url" :target="target">
      <slot></slot>
    </Link>
    <button v-else-if="isButton" :class="classname" @click="action">
      <slot></slot>
    </button>
    <span v-else :class="classname">
      <slot></slot>
    </span>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'ui-button',

    components: {
      Link,
    },

    props: {
        link: Object,
        link_url: {
          type: String,
          default: '',
        },
        size: {
          type: String,
          default: '',
        },
        color: {
          type: String,
          default: '',
        },
        target: {
          type: String,
          default: ''
        },
        isButton: {
          type: Boolean,
          default: false
        },
        action: {
          type: Function,
          default: () => null,
        }
    },

    data() {
      return {
        classname: ['ui-button'],
      }
    },

    mounted() {
      if (this.size) this.classname.push('size-' + this.size);
      if (this.color) this.classname.push('color-' + this.color);
    },
}

</script>

<style lang="scss">

    a.ui-button,
    button.ui-button {
      cursor: pointer;
      background-color: transparent;
    }

    a.ui-button:hover,
    button.ui-button:hover {
      color: white;
      background-color: black;
      opacity: 1;
      border-color: transparent;
    }

    a.ui-button.color-white:hover
    button.ui-button.color-white:hover {
      background-color: black;
    }

    .ui-button {
      display: inline-block;
      line-height: 1;
      border: 2px solid;
      // text-transform: uppercase;
      // cursor: pointer;
      padding: 1rem 2rem;

      &.text-button {
        border-color: rgba(#000, 0) !important;
      }

      &.size-large {
        padding: var(--padding-50) var(--padding-x2);
        font-size: var(--medium-size);
      }

      &.size-small {
        padding: .65rem 1rem;
        font-size: var(--small-size);
        border-width: 1px;
      }

      &.color-black {
        color: black;

        &:hover {
          background: white;
        }
      }

      &.color-black-full {
        color: white;
        background: black;

        &:hover {
          color: black;
          background: white;
        }
      }

      &.color-white {
        color: white;
        &:hover {
          background: white;
          color: black;
        }
      }
    }

    @media only screen and (max-width: 767px) {
      .ui-button {
        border-width: 1px;
      }
    }
</style>
